/** @jsx jsx */
import { useContext } from 'react'
import { css, jsx, keyframes } from '@emotion/core'
import { Button } from '@livechat/design-system'

import { Context } from '../context'
import { VIEWS } from '../constants'

import addIcon from '../assets/images/white-add.png'

const showAnimation = keyframes`
 from {
  transform: scale(0.95);
 }
`

const headerCss = css`
  width: calc(100vw - 200px);
  height: 55px;
  border-bottom: 1px solid #d8dee5;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 855px) {
    display: none;
  }

  .label {
    font-weight: 400;
    font-size: 16px;
    animation: ${showAnimation} 0.2s ease;
    transition: content 0.2s ease-in-out;
  }

  .add {
    width: 10px;
    margin-right: 5px;
    margin-top: 1px;
  }

  .lc-btn {
    padding: 6px 12px;
    position: absolute;
    right: 16px;
  }
`

const Header = () => {
  const {
    view,
    redirectToSandbox,
    resetSandboxSurvey,
    setIsTemplate,
  } = useContext(Context)

  const onClick = () => {
    resetSandboxSurvey()
    setIsTemplate()
    redirectToSandbox()
  }

  return (
    <header css={headerCss}>
      <span className="label">
        {view.charAt(0).toUpperCase() + view.slice(1).toLowerCase()}
      </span>
      {view === VIEWS.SURVEYS && (
        <Button onClick={onClick} primary>
          <img src={addIcon} alt="add" className="add" /> New Survey
        </Button>
      )}
    </header>
  )
}

export default Header
